export default {
  mounted(el) {
    el.classList.add("scroll-fade-in");

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          el.classList.add("is-visible");
          observer.unobserve(el); // opcional, evita que se observe más veces
        }
      },
      {
        threshold: 0.1
      }
    );

    observer.observe(el);
  }
};
